module.exports = __webpack_public_path__ + "img/4.158f20ab.png";